import { render } from "./DebugComponent.vue?vue&type=template&id=9fdbd140"
import script from "./DebugComponent.vue?vue&type=script&lang=js"
export * from "./DebugComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__